import Typography from "@mui/material/Typography";

import { RatingStarRecipe } from "../iconRef/recipePageIcons";
import styles from './recipeCard.module.css';

const RatingDisplay = ({ rating }: { rating: number }) => {

    const ratingValue = rating.toFixed(1);

    return (
        <div className={styles.rating_container}>
            <div className={styles.rating_icon} >
                <RatingStarRecipe />
            </div>
            <div className={styles.rating_text}>
                <Typography variant="ratingText">
                    {ratingValue}
                </Typography>
            </div>
        </div>
    );
};

export default RatingDisplay;
